var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hxlHeader'),_c('router-view'),_c('hxlFooder')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }